<div class="ibox detailed-view-ibox"
     *ngIf="keyLogService.showDetailedView && keyLogService.selectedItemData">
    <div class="detailed-view-header">
        <div class="detailed-view-amenity-name">{{keyLogService.selectedItemData.keyTag}}</div>
        <span class="close-detailed-view" (click)="keyLogService.toggleDetailedView(null)">×</span>
    </div>
    <div class="detailed-view-body">
        <div class="detailed-view__more-info m-t-md" [ngClass]="{'no-action-button': actionButtonIsNotAvailable()}">
            <form #form="ngForm" submittable autocomplete="off">
                <div>
                    <div class="detailed-view-navigation">
                        <div class="col-md-6 col-sm-6 col-xs-6 no-padding">
                            <div class="button-section" (click)="changeNavPosition('details')"
                                 [ngStyle]="{'background-color': navPosition == 'details' ? '#ebebeb' : ''}">
                                Details
                            </div>
                        </div>
                        <div class="col-md-6 col-sm-6 col-xs-6 no-padding">
                            <div class="button-section" (click)="changeNavPosition('history')"
                                 [ngStyle]="{'background-color': navPosition == 'history' ? '#ebebeb' : ''}">
                                History
                            </div>
                        </div>
                    </div>
                </div>
                <div class="general-tab" *ngIf="navPosition == 'details'">
                    <input-field name="keyTag"
                                 [ngModel]="keyLogService.selectedItemData.keyTag"
                                 [title]="'Key Tag'"
                                 [tooltipText]="'Key Tag'"
                                 [noEdit]="!keyLogService.selectedItemData.isCanEdit"
                                 (update)="onSubmit({keyTag: form.value.keyTag})">
                    </input-field>
                    <div class="row m-b-xs" (dblclick)="turnEditModeOn()">
                        <div class="col-md-3" *ngIf="keyLogService.buildingsForUpdate.length > 1">
                            <label style="font-size: 12px;" class="m-t-xs">Building</label>
                        </div>
                        <div class="col-md-9 m-b-sm fourteenPixelText"
                             [class.hidden]="!keyLogService.selectedItemData.formFields.unit.editMode || keyLogService.buildingsForUpdate.length < 2">
                            <select class="form-control"
                                    name="buildingId"
                                    style="height: 28px; padding: 3px 12px;"
                                    [ngModel]="keyLogService.selectedItemData.buildingId"
                                    required #buildingSelect
                                    (change)="changeBuilding($event.target.value)"
                                    [disabled]="buildingSelectIsDisabled">
                                <option value="" hidden></option>
                                <option *ngFor="let build of keyLogService.buildingsForUpdate" [value]="build.id">
                                    {{build.name}}
                                </option>
                            </select>
                        </div>
                        <div class="col-md-9 m-b-sm dv-value"
                             [class.hidden]="keyLogService.selectedItemData.formFields.unit.editMode || keyLogService.buildingsForUpdate.length < 2">
                            {{keyLogService.selectedItemData.buildingName || '-'}}
                        </div>

                        <div class="col-md-3">
                            <label style="font-size: 12px;" class="m-t-xs">Unit/Room</label>
                        </div>
                        <div class="col-md-9 m-b-sm" *ngIf="keyLogService.selectedItemData.formFields.unit.editMode">
                            <search-select [ngModel]="keyLogService.selectedItemData.suiteId"
                                           name="suiteId"
                                           required #suiteSelect
                                           (ngModelChange)="changeUnit($event)"
                                           [data]="suiteToSearchSelect(suites)">
                            </search-select>
                            <input *ngIf="suiteSelect.value == '0'"
                                   class="form-control"
                                   name="otherSuite"
                                   style="height: 26px;"
                                   [ngModel]="keyLogService.selectedItemData.suiteNumber"
                                   placeholder="Other Unit Number"
                                   maxlength="255" required>
                            <spinner [spinnerShow]="buildingSelect.value &&
                                                buildingSelect.value != 'null' &&
                                                !suites.length">
                            </spinner>
                        </div>
                        <div class="col-md-9 dv-value" *ngIf="!keyLogService.selectedItemData.formFields.unit.editMode">
                            {{keyLogService.selectedItemData.suiteNumber || '-'}}
                            <i *ngIf="!noEdit && keyLogService.selectedItemData.isCanEdit"
                               class="fa fa-pencil pull-right"
                               (click)="turnEditModeOn()"
                               data-toggle="tooltip"
                               data-placement="top"
                               title="Edit">
                            </i>
                        </div>

                        <div class="col-md-12" *ngIf="keyLogService.selectedItemData.formFields.unit.editMode">
                            <div class="pull-right dv-value-edit">
                                <button *ngIf="keyLogService.selectedItemData.isCanEdit"
                                        style="border-left: 1px solid #dedfe0;"
                                        type="button"
                                        [disabled]="noEdit"
                                        (click)="submitUnitField()">
                                    <i class="fa fa-check"></i>
                                </button>

                                <button *ngIf="keyLogService.selectedItemData.isCanEdit"
                                        type="button"
                                        [disabled]="noEdit"
                                        (click)="keyLogService.selectedItemData.formFields.unit.editMode = false;">
                                    <i class="fa fa-times"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                    <input-field name="purpose"
                                 [ngModel]="keyLogService.selectedItemData.purpose"
                                 [title]="'Purpose'"
                                 [tooltipText]="'Purpose'"
                                 [noEdit]="!keyLogService.selectedItemData.isCanEdit"
                                 (update)="onSubmit({purpose: form.value.purpose})">
                    </input-field>
                    <div class="row m-b-xs">
                        <div class="col-md-3">
                            <label>Status</label>
                        </div>
                        <div class="col-md-9">
                            <span *ngIf="keyLogService.selectedItemData.status === 'available'"
                                  class="text-uppercase label label-picked_up">
                                Available
                            </span>
                            <span *ngIf="keyLogService.selectedItemData.status === 'signet_out'"
                                  class="text-uppercase label label-received">
                                Signed Out
                            </span>
                        </div>
                    </div>
                    <textarea-field name="notes"
                                    [ngModel]="keyLogService.selectedItemData.notes"
                                    [maxLength]="255"
                                    [title]="'Notes'"
                                    [tooltipText]="'Notes'"
                                    [noEdit]="!keyLogService.selectedItemData.isCanEdit"
                                    (update)="onSubmit({notes: form.value.notes})">
                    </textarea-field>

                    <hr *ngIf="keyLogService.activities.length > 0">

                    <div *ngIf="keyLogService.activities.length > 0">
                        <div class="row">
                            <div class="col-md-3">
                                <label>
                                    {{ keyLogService.activities[0].status == 'signet_out' ? 'Issued to' :'Returned by'}}
                                </label>
                            </div>
                            <div class="col-md-9">
                                {{keyLogService.activities[0].user.fullName}}
                            </div>
                        </div>
                        <div class="row" *ngIf="keyLogService.activities[0].activityNotes">
                            <div class="col-md-3">
                                <label>Release Notes</label>
                            </div>
                            <div class="col-md-9">
                                {{keyLogService.activities[0].activityNotes}}
                            </div>
                        </div>
                        <div class="signatureImage m-t-md" *ngIf="keyLogService.activities[0].signUrl">
                            <img [src]="keyLogService.activities[0].signUrl">
                        </div>
                    </div>
                </div>
                <div class="content" *ngIf="navPosition == 'history'">
                    <div class="timeline remove-vertical-scrollbar">
                        <spinner [spinnerShow]="keyLogService.detailedViewHistorySpinnerShow"></spinner>
                        <ul class="timeline__list no-bottom-gap">
                            <li *ngFor="let a of keyLogService.activities">
                                <section>
                                    <header class="timeline__header">
                                        <span>
                                            <time>{{ a.createdAt | date:'dd.MM.yyyy hh:mm a' }}</time> by {{ a.createdBy ? a.createdBy.fullName : '' }}
                                        </span>
                                    </header>

                                    <main class="timeline__content">
                                        <div>
                                            {{ a.status == 'signet_out' ? 'Issued to' :'Returned by'}}
                                            <span class="timeline__active">{{a.user ? a.user.fullName : 'N/A'}}</span>
                                            <!--Signature-->
                                            <div class="signatureImage m-t-md" *ngIf="a.signUrl">
                                                <img [src]="a.signUrl">
                                            </div>
                                        </div>
                                        <div *ngIf="a.activityNotes" class="activity-notes">{{a.activityNotes}}</div>
                                    </main>
                                </section>
                            </li>
                        </ul>

                        <div *ngIf="!keyLogService.activities.length && !keyLogService.detailedViewHistorySpinnerShow" class="no-history">
                            There are no history records about this Key Log
                        </div>
                    </div>
                </div>

                <hr *ngIf="keyLogService.selectedItemData.isCanEdit || keyLogService.selectedItemData.isCanDelete">

                <div class="btn-group dropup"
                     *ngIf="keyLogService.selectedItemData.isCanEdit || keyLogService.selectedItemData.isCanDelete">
                    <a data-toggle="dropdown" class="btn btn-primary btn-sm dropdown-toggle">
                        Actions <span class="caret"></span>
                    </a>
                    <ul class="dropdown-menu">
                        <!--<li *ngIf="keyLogService.selectedItemData.isCanEdit"-->
                        <!--(click)="keyLogService.editKeyLog(keyLogService.selectedItemData)">-->
                        <!--<a>Edit</a>-->
                        <!--</li>-->
                        <!--<li (click)="keyLogService.viewKeyLog(keyLogService.selectedItemData)" ><a>View</a></li>-->
                        <li *ngIf="keyLogService.selectedItemData.isCanDelete"
                            (click)="keyLogService.deleteKeyLog(keyLogService.selectedItemData)">
                            <a>Delete</a>
                        </li>
                        <li (click)="keyLogService.signOutKey(keyLogService.selectedItemData)"
                            *ngIf="keyLogService.selectedItemData.status === 'available' && keyLogService.selectedItemData.isCanEdit">
                            <a>Sign Out Key</a>
                        </li>
                        <li (click)="keyLogService.returnKey(keyLogService.selectedItemData)"
                            *ngIf="keyLogService.selectedItemData.status === 'signet_out' && keyLogService.selectedItemData.isCanEdit">
                            <a>Return Key</a>
                        </li>
                    </ul>
                </div>
            </form>
        </div>
    </div>
</div>



// WEBPACK FOOTER //
// /app/src/app/views/key-log/key-log-detailed-view/key-log-detailed-view.component.html